import { jsx as S, jsxs as Ie } from "react/jsx-runtime";
import { M as Ne } from "./react-icons.esm-CDi78UIJ.js";
import { R as Re, P as $e, O as Me, C as Ae } from "./index-Bxq-rK0V.js";
import * as l from "react";
import { forwardRef as V } from "react";
import { P as N } from "./index-BrTLHETv.js";
import { u as L } from "./index-umR1UobZ.js";
import { s as De } from "./index-BLPblar-.js";
import { $ as F } from "./utils-CTvPli9r.js";
import { Dialog as Pe, DialogContent as Ve } from "./dialog.js";
var ve = 1, Fe = 0.9, Ke = 0.8, Le = 0.17, Z = 0.1, ee = 0.999, _e = 0.9999, je = 0.99, qe = /[\\\/_+.#"@\[\(\{&]/, ze = /[\\\/_+.#"@\[\(\{&]/g, Ge = /[\s-]/, be = /[\s-]/g;
function re(e, n, t, m, o, i, c) {
  if (i === n.length) return o === e.length ? ve : je;
  var p = `${o},${i}`;
  if (c[p] !== void 0) return c[p];
  for (var h = m.charAt(i), f = t.indexOf(h, o), d = 0, v, C, w, I; f >= 0; ) v = re(e, n, t, m, f + 1, i + 1, c), v > d && (f === o ? v *= ve : qe.test(e.charAt(f - 1)) ? (v *= Ke, w = e.slice(o, f - 1).match(ze), w && o > 0 && (v *= Math.pow(ee, w.length))) : Ge.test(e.charAt(f - 1)) ? (v *= Fe, I = e.slice(o, f - 1).match(be), I && o > 0 && (v *= Math.pow(ee, I.length))) : (v *= Le, o > 0 && (v *= Math.pow(ee, f - o))), e.charAt(f) !== n.charAt(i) && (v *= _e)), (v < Z && t.charAt(f - 1) === m.charAt(i + 1) || m.charAt(i + 1) === m.charAt(i) && t.charAt(f - 1) !== m.charAt(i)) && (C = re(e, n, t, m, f + 1, i + 2, c), C * Z > v && (v = C * Z)), v > d && (d = v), f = t.indexOf(h, f + 1);
  return c[p] = d, d;
}
function ge(e) {
  return e.toLowerCase().replace(be, " ");
}
function Oe(e, n, t) {
  return e = t && t.length > 0 ? `${e + " " + t.join(" ")}` : e, re(e, n, ge(e), ge(n), 0, 0, {});
}
var q = '[cmdk-group=""]', te = '[cmdk-group-items=""]', He = '[cmdk-group-heading=""]', le = '[cmdk-item=""]', he = `${le}:not([aria-disabled="true"])`, ne = "cmdk-item-select", A = "data-value", Ue = (e, n, t) => Oe(e, n, t), ye = l.createContext(void 0), G = () => l.useContext(ye), xe = l.createContext(void 0), ae = () => l.useContext(xe), ke = l.createContext(void 0), we = l.forwardRef((e, n) => {
  let t = K(() => {
    var r, u;
    return { search: "", value: (u = (r = e.value) != null ? r : e.defaultValue) != null ? u : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), m = K(() => /* @__PURE__ */ new Set()), o = K(() => /* @__PURE__ */ new Map()), i = K(() => /* @__PURE__ */ new Map()), c = K(() => /* @__PURE__ */ new Set()), p = Ee(e), { label: h, children: f, value: d, onValueChange: v, filter: C, shouldFilter: w, loop: I, disablePointerSelection: B = !1, vimBindings: R = !0, ...O } = e, oe = L(), ue = L(), ie = L(), $ = l.useRef(null), y = rt();
  D(() => {
    if (d !== void 0) {
      let r = d.trim();
      t.current.value = r, k.emit();
    }
  }, [d]), D(() => {
    y(6, ce);
  }, []);
  let k = l.useMemo(() => ({ subscribe: (r) => (c.current.add(r), () => c.current.delete(r)), snapshot: () => t.current, setState: (r, u, s) => {
    var a, g, b;
    if (!Object.is(t.current[r], u)) {
      if (t.current[r] = u, r === "search") X(), W(), y(1, J);
      else if (r === "value" && (s || y(5, ce), ((a = p.current) == null ? void 0 : a.value) !== void 0)) {
        let E = u ?? "";
        (b = (g = p.current).onValueChange) == null || b.call(g, E);
        return;
      }
      k.emit();
    }
  }, emit: () => {
    c.current.forEach((r) => r());
  } }), []), T = l.useMemo(() => ({ value: (r, u, s) => {
    var a;
    u !== ((a = i.current.get(r)) == null ? void 0 : a.value) && (i.current.set(r, { value: u, keywords: s }), t.current.filtered.items.set(r, de(u, s)), y(2, () => {
      W(), k.emit();
    }));
  }, item: (r, u) => (m.current.add(r), u && (o.current.has(u) ? o.current.get(u).add(r) : o.current.set(u, /* @__PURE__ */ new Set([r]))), y(3, () => {
    X(), W(), t.current.value || J(), k.emit();
  }), () => {
    i.current.delete(r), m.current.delete(r), t.current.filtered.items.delete(r);
    let s = _();
    y(4, () => {
      X(), (s == null ? void 0 : s.getAttribute("id")) === r && J(), k.emit();
    });
  }), group: (r) => (o.current.has(r) || o.current.set(r, /* @__PURE__ */ new Set()), () => {
    i.current.delete(r), o.current.delete(r);
  }), filter: () => p.current.shouldFilter, label: h || e["aria-label"], getDisablePointerSelection: () => p.current.disablePointerSelection, listId: oe, inputId: ie, labelId: ue, listInnerRef: $ }), []);
  function de(r, u) {
    var s, a;
    let g = (a = (s = p.current) == null ? void 0 : s.filter) != null ? a : Ue;
    return r ? g(r, t.current.search, u) : 0;
  }
  function W() {
    if (!t.current.search || p.current.shouldFilter === !1) return;
    let r = t.current.filtered.items, u = [];
    t.current.filtered.groups.forEach((a) => {
      let g = o.current.get(a), b = 0;
      g.forEach((E) => {
        let M = r.get(E);
        b = Math.max(M, b);
      }), u.push([a, b]);
    });
    let s = $.current;
    j().sort((a, g) => {
      var b, E;
      let M = a.getAttribute("id"), H = g.getAttribute("id");
      return ((b = r.get(H)) != null ? b : 0) - ((E = r.get(M)) != null ? E : 0);
    }).forEach((a) => {
      let g = a.closest(te);
      g ? g.appendChild(a.parentElement === g ? a : a.closest(`${te} > *`)) : s.appendChild(a.parentElement === s ? a : a.closest(`${te} > *`));
    }), u.sort((a, g) => g[1] - a[1]).forEach((a) => {
      var g;
      let b = (g = $.current) == null ? void 0 : g.querySelector(`${q}[${A}="${encodeURIComponent(a[0])}"]`);
      b == null || b.parentElement.appendChild(b);
    });
  }
  function J() {
    let r = j().find((s) => s.getAttribute("aria-disabled") !== "true"), u = r == null ? void 0 : r.getAttribute(A);
    k.setState("value", u || void 0);
  }
  function X() {
    var r, u, s, a;
    if (!t.current.search || p.current.shouldFilter === !1) {
      t.current.filtered.count = m.current.size;
      return;
    }
    t.current.filtered.groups = /* @__PURE__ */ new Set();
    let g = 0;
    for (let b of m.current) {
      let E = (u = (r = i.current.get(b)) == null ? void 0 : r.value) != null ? u : "", M = (a = (s = i.current.get(b)) == null ? void 0 : s.keywords) != null ? a : [], H = de(E, M);
      t.current.filtered.items.set(b, H), H > 0 && g++;
    }
    for (let [b, E] of o.current) for (let M of E) if (t.current.filtered.items.get(M) > 0) {
      t.current.filtered.groups.add(b);
      break;
    }
    t.current.filtered.count = g;
  }
  function ce() {
    var r, u, s;
    let a = _();
    a && (((r = a.parentElement) == null ? void 0 : r.firstChild) === a && ((s = (u = a.closest(q)) == null ? void 0 : u.querySelector(He)) == null || s.scrollIntoView({ block: "nearest" })), a.scrollIntoView({ block: "nearest" }));
  }
  function _() {
    var r;
    return (r = $.current) == null ? void 0 : r.querySelector(`${le}[aria-selected="true"]`);
  }
  function j() {
    var r;
    return Array.from(((r = $.current) == null ? void 0 : r.querySelectorAll(he)) || []);
  }
  function Y(r) {
    let u = j()[r];
    u && k.setState("value", u.getAttribute(A));
  }
  function Q(r) {
    var u;
    let s = _(), a = j(), g = a.findIndex((E) => E === s), b = a[g + r];
    (u = p.current) != null && u.loop && (b = g + r < 0 ? a[a.length - 1] : g + r === a.length ? a[0] : a[g + r]), b && k.setState("value", b.getAttribute(A));
  }
  function se(r) {
    let u = _(), s = u == null ? void 0 : u.closest(q), a;
    for (; s && !a; ) s = r > 0 ? et(s, q) : tt(s, q), a = s == null ? void 0 : s.querySelector(he);
    a ? k.setState("value", a.getAttribute(A)) : Q(r);
  }
  let me = () => Y(j().length - 1), fe = (r) => {
    r.preventDefault(), r.metaKey ? me() : r.altKey ? se(1) : Q(1);
  }, pe = (r) => {
    r.preventDefault(), r.metaKey ? Y(0) : r.altKey ? se(-1) : Q(-1);
  };
  return l.createElement(N.div, { ref: n, tabIndex: -1, ...O, "cmdk-root": "", onKeyDown: (r) => {
    var u;
    if ((u = O.onKeyDown) == null || u.call(O, r), !r.defaultPrevented) switch (r.key) {
      case "n":
      case "j": {
        R && r.ctrlKey && fe(r);
        break;
      }
      case "ArrowDown": {
        fe(r);
        break;
      }
      case "p":
      case "k": {
        R && r.ctrlKey && pe(r);
        break;
      }
      case "ArrowUp": {
        pe(r);
        break;
      }
      case "Home": {
        r.preventDefault(), Y(0);
        break;
      }
      case "End": {
        r.preventDefault(), me();
        break;
      }
      case "Enter":
        if (!r.nativeEvent.isComposing && r.keyCode !== 229) {
          r.preventDefault();
          let s = _();
          if (s) {
            let a = new Event(ne);
            s.dispatchEvent(a);
          }
        }
    }
  } }, l.createElement("label", { "cmdk-label": "", htmlFor: T.inputId, id: T.labelId, style: lt }, h), U(e, (r) => l.createElement(xe.Provider, { value: k }, l.createElement(ye.Provider, { value: T }, r))));
}), Be = l.forwardRef((e, n) => {
  var t, m;
  let o = L(), i = l.useRef(null), c = l.useContext(ke), p = G(), h = Ee(e), f = (m = (t = h.current) == null ? void 0 : t.forceMount) != null ? m : c == null ? void 0 : c.forceMount;
  D(() => {
    if (!f) return p.item(o, c == null ? void 0 : c.id);
  }, [f]);
  let d = Se(o, i, [e.value, e.children, i], e.keywords), v = ae(), C = P((y) => y.value && y.value === d.current), w = P((y) => f || p.filter() === !1 ? !0 : y.search ? y.filtered.items.get(o) > 0 : !0);
  l.useEffect(() => {
    let y = i.current;
    if (!(!y || e.disabled)) return y.addEventListener(ne, I), () => y.removeEventListener(ne, I);
  }, [w, e.onSelect, e.disabled]);
  function I() {
    var y, k;
    B(), (k = (y = h.current).onSelect) == null || k.call(y, d.current);
  }
  function B() {
    v.setState("value", d.current, !0);
  }
  if (!w) return null;
  let { disabled: R, value: O, onSelect: oe, forceMount: ue, keywords: ie, ...$ } = e;
  return l.createElement(N.div, { ref: z([i, n]), ...$, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!R, "aria-selected": !!C, "data-disabled": !!R, "data-selected": !!C, onPointerMove: R || p.getDisablePointerSelection() ? void 0 : B, onClick: R ? void 0 : I }, e.children);
}), Te = l.forwardRef((e, n) => {
  let { heading: t, children: m, forceMount: o, ...i } = e, c = L(), p = l.useRef(null), h = l.useRef(null), f = L(), d = G(), v = P((w) => o || d.filter() === !1 ? !0 : w.search ? w.filtered.groups.has(c) : !0);
  D(() => d.group(c), []), Se(c, p, [e.value, e.heading, h]);
  let C = l.useMemo(() => ({ id: c, forceMount: o }), [o]);
  return l.createElement(N.div, { ref: z([p, n]), ...i, "cmdk-group": "", role: "presentation", hidden: v ? void 0 : !0 }, t && l.createElement("div", { ref: h, "cmdk-group-heading": "", "aria-hidden": !0, id: f }, t), U(e, (w) => l.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": t ? f : void 0 }, l.createElement(ke.Provider, { value: C }, w))));
}), We = l.forwardRef((e, n) => {
  let { alwaysRender: t, ...m } = e, o = l.useRef(null), i = P((c) => !c.search);
  return !t && !i ? null : l.createElement(N.div, { ref: z([o, n]), ...m, "cmdk-separator": "", role: "separator" });
}), Je = l.forwardRef((e, n) => {
  let { onValueChange: t, ...m } = e, o = e.value != null, i = ae(), c = P((d) => d.search), p = P((d) => d.value), h = G(), f = l.useMemo(() => {
    var d;
    let v = (d = h.listInnerRef.current) == null ? void 0 : d.querySelector(`${le}[${A}="${encodeURIComponent(p)}"]`);
    return v == null ? void 0 : v.getAttribute("id");
  }, []);
  return l.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), l.createElement(N.input, { ref: n, ...m, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": h.listId, "aria-labelledby": h.labelId, "aria-activedescendant": f, id: h.inputId, type: "text", value: o ? e.value : c, onChange: (d) => {
    o || i.setState("search", d.target.value), t == null || t(d.target.value);
  } });
}), Xe = l.forwardRef((e, n) => {
  let { children: t, label: m = "Suggestions", ...o } = e, i = l.useRef(null), c = l.useRef(null), p = G();
  return l.useEffect(() => {
    if (c.current && i.current) {
      let h = c.current, f = i.current, d, v = new ResizeObserver(() => {
        d = requestAnimationFrame(() => {
          let C = h.offsetHeight;
          f.style.setProperty("--cmdk-list-height", C.toFixed(1) + "px");
        });
      });
      return v.observe(h), () => {
        cancelAnimationFrame(d), v.unobserve(h);
      };
    }
  }, []), l.createElement(N.div, { ref: z([i, n]), ...o, "cmdk-list": "", role: "listbox", "aria-label": m, id: p.listId }, U(e, (h) => l.createElement("div", { ref: z([c, p.listInnerRef]), "cmdk-list-sizer": "" }, h)));
}), Ye = l.forwardRef((e, n) => {
  let { open: t, onOpenChange: m, overlayClassName: o, contentClassName: i, container: c, ...p } = e;
  return l.createElement(Re, { open: t, onOpenChange: m }, l.createElement($e, { container: c }, l.createElement(Me, { "cmdk-overlay": "", className: o }), l.createElement(Ae, { "aria-label": e.label, "cmdk-dialog": "", className: i }, l.createElement(we, { ref: n, ...p }))));
}), Qe = l.forwardRef((e, n) => P((t) => t.filtered.count === 0) ? l.createElement(N.div, { ref: n, ...e, "cmdk-empty": "", role: "presentation" }) : null), Ze = l.forwardRef((e, n) => {
  let { progress: t, children: m, label: o = "Loading...", ...i } = e;
  return l.createElement(N.div, { ref: n, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": t, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, U(e, (c) => l.createElement("div", { "aria-hidden": !0 }, c)));
}), x = Object.assign(we, { List: Xe, Item: Be, Input: Je, Group: Te, Separator: We, Dialog: Ye, Empty: Qe, Loading: Ze });
function et(e, n) {
  let t = e.nextElementSibling;
  for (; t; ) {
    if (t.matches(n)) return t;
    t = t.nextElementSibling;
  }
}
function tt(e, n) {
  let t = e.previousElementSibling;
  for (; t; ) {
    if (t.matches(n)) return t;
    t = t.previousElementSibling;
  }
}
function Ee(e) {
  let n = l.useRef(e);
  return D(() => {
    n.current = e;
  }), n;
}
var D = typeof window > "u" ? l.useEffect : l.useLayoutEffect;
function K(e) {
  let n = l.useRef();
  return n.current === void 0 && (n.current = e()), n;
}
function z(e) {
  return (n) => {
    e.forEach((t) => {
      typeof t == "function" ? t(n) : t != null && (t.current = n);
    });
  };
}
function P(e) {
  let n = ae(), t = () => e(n.snapshot());
  return De.useSyncExternalStore(n.subscribe, t, t);
}
function Se(e, n, t, m = []) {
  let o = l.useRef(), i = G();
  return D(() => {
    var c;
    let p = (() => {
      var f;
      for (let d of t) {
        if (typeof d == "string") return d.trim();
        if (typeof d == "object" && "current" in d) return d.current ? (f = d.current.textContent) == null ? void 0 : f.trim() : o.current;
      }
    })(), h = m.map((f) => f.trim());
    i.value(e, p, h), (c = n.current) == null || c.setAttribute(A, p), o.current = p;
  }), o;
}
var rt = () => {
  let [e, n] = l.useState(), t = K(() => /* @__PURE__ */ new Map());
  return D(() => {
    t.current.forEach((m) => m()), t.current = /* @__PURE__ */ new Map();
  }, [e]), (m, o) => {
    t.current.set(m, o), n({});
  };
};
function nt(e) {
  let n = e.type;
  return typeof n == "function" ? n(e.props) : "render" in n ? n.render(e.props) : e;
}
function U({ asChild: e, children: n }, t) {
  return e && l.isValidElement(n) ? l.cloneElement(nt(n), { ref: n.ref }, t(n.props.children)) : t(n);
}
var lt = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Ce = V(({ className: e, ...n }, t) => /* @__PURE__ */ S(
  x,
  {
    ref: t,
    className: F(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...n
  }
));
Ce.displayName = x.displayName;
const kt = ({ children: e, ...n }) => /* @__PURE__ */ S(Pe, { ...n, children: /* @__PURE__ */ S(Ve, { className: "overflow-hidden p-0", children: /* @__PURE__ */ S(Ce, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:size-5", children: e }) }) }), at = V(({ className: e, ...n }, t) => /* @__PURE__ */ Ie("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ S(Ne, { className: "mr-2 size-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ S(
    x.Input,
    {
      ref: t,
      className: F(
        "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...n
    }
  )
] }));
at.displayName = x.Input.displayName;
const ot = V(({ className: e, ...n }, t) => /* @__PURE__ */ S(
  x.List,
  {
    ref: t,
    className: F("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...n
  }
));
ot.displayName = x.List.displayName;
const ut = V((e, n) => /* @__PURE__ */ S(x.Empty, { ref: n, className: "py-6 text-center text-sm", ...e }));
ut.displayName = x.Empty.displayName;
const it = V(({ className: e, ...n }, t) => /* @__PURE__ */ S(
  x.Group,
  {
    ref: t,
    className: F(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...n
  }
));
it.displayName = x.Group.displayName;
const dt = V(({ className: e, ...n }, t) => /* @__PURE__ */ S(x.Separator, { ref: t, className: F("-mx-1 h-px bg-border", e), ...n }));
dt.displayName = x.Separator.displayName;
const ct = V(({ className: e, ...n }, t) => /* @__PURE__ */ S(
  x.Item,
  {
    ref: t,
    className: F(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-[selected='true']:bg-accent aria-[selected='true']:text-accent-foreground data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50",
      e
    ),
    ...n
  }
));
ct.displayName = x.Item.displayName;
const st = ({ className: e, ...n }) => /* @__PURE__ */ S("span", { className: F("ml-auto text-xs tracking-widest text-muted-foreground", e), ...n });
st.displayName = "CommandShortcut";
export {
  Ce as C,
  P as T,
  x as V,
  kt as a,
  at as b,
  ot as c,
  ut as d,
  it as e,
  ct as f,
  st as g,
  dt as h
};
//# sourceMappingURL=command-ClHioAv1.js.map
